import { keywords } from '../parser/keywords.js';
import { isOnlyExpressionSupported } from '../parser/utils/testOnlyUtils.js';
import { getDecoratorInfo } from './decoratorUtils.js';

/**
 * Decorator to mark a test class or function as 'only' for execution filtering.
 * 
 * When applied to a class, it marks the entire suite.
 * When applied to a method, it marks that specific test.
 * 
 * @param expressionArg - Optional filter expression:
 * - `true` or no argument: Runs the test.
 * - `number`: Number of tests to run from the group.
 * - `'*'`: Runs all tests in the group.
 */
export function testOnly(expressionArg?: number | string) {
  const expression = arguments.length === 0 ? 1 : expressionArg;

  return function (targetProto: any, childKey?: string) {
    const decInfo = getDecoratorInfo(childKey);
    const exprSupported = isOnlyExpressionSupported(expression);

    if (decInfo.isClass && exprSupported === false) {
      throw new Error(createErrorMessage(expression, targetProto.name));
    }

    if (decInfo.isClass) {
      targetProto[keywords.only] = true;
      return;
    }

    const target = targetProto[decInfo.key!];
    const isFunction = target instanceof Function;

    if (isFunction === false) {
      throw new Error(createErrorMessage(expression, targetProto.constructor.name));
    }

    if (exprSupported === false) {
      throw new Error(createErrorMessage(expression, targetProto.constructor.name));
    }

    target[keywords.only] = expression === undefined ? 1 : expression;
  }
}

function createErrorMessage(expression: any, targetName: string) {
  return `testOnly('${expression}') expression on '${targetName}' not supported`;
}
